// Overwritten by Env File, but good if we want to add dynamic env switching
export const GameLicenses = {
    "dev"   : "56d11073-cbd1-4d8f-b402-ef970b360c65",
    "test"  : "---------- Does not exist ----------",
    "stg"   : "6a795c3a-955f-4f71-85da-454b7f902bd8",
    "prod"  : "3ab9a496-66cb-4826-b1bf-62e8734e2e40",
};

export const rmbStatus = {
    "Disconnected"  : 'Disconnected',
    "Connecting"    : 'Connecting',
    "Connected"     : 'Connected'
};

export const GetCurrentTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const cachedParamsTag = 'cached_params';
export const GetUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const result = {};

    params.forEach((value, key) => {
        result[key] = value;
    });

    return result;
};

export const RemoveUrlParam = (param) => {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);

  // Update the URL in the address bar without reloading
  window.history.replaceState({}, "", url.toString());
};

export const CacheUrlParams = () => {
    const params = new URLSearchParams(window.location.search);
    const result = {};

    params.forEach((value, key) => {
        if(key != 'code' && key != 'state')
        {
            result[key] = value;
            RemoveUrlParam(key);
        }
    });

    let cachedJson = localStorage.getItem(cachedParamsTag);
    if (cachedJson !== null && cachedJson !== '') {
        let cachedParams = JSON.parse(cachedJson);

        // Update cachedParams with key/values from result 
        // but only if the value is not null or empty (unsure if we need this gate)
        Object.entries(result).forEach(([key, value]) => {
            //if (value !== null && value !== "") {
                cachedParams[key] = value;
            //}
        });

        const json = JSON.stringify(cachedParams);
        localStorage.setItem(cachedParamsTag, json);
    } else {
        const json = JSON.stringify(result);
        localStorage.setItem(cachedParamsTag, json);
    }
    console.log(`[CacheUrlParams] updated cached params with: ${localStorage.getItem(cachedParamsTag)}`);
};

export const GetCachedUrlParams = () => {
    let cachedJson = localStorage.getItem(cachedParamsTag);
    if (cachedJson !== null && cachedJson !== '') {
        let cachedParams = JSON.parse(cachedJson);
        return cachedParams;
    } else {
        return {};
    }
};

// Player Settings' "Graphics Quality" choice (SettingKey_Player_Quality on the Unity side,
// pushed over via UnityToWeb.UpdateQuality) - kept separate from cachedParamsTag since it's not
// a URL param, and read at Unity component mount time (GamePage.js's getQualitySetting) rather
// than fed to Unity - react-unity-webgl bakes devicePixelRatio into a one-shot useMemo, so a
// change only takes effect after the page reload UnityUpdateQuality triggers.
const qualityPrefTag = 'graphics_quality_pref';
export const GetQualityPreference = () => {
    return localStorage.getItem(qualityPrefTag);
};
export const SetQualityPreference = (value) => {
    localStorage.setItem(qualityPrefTag, value);
    console.log(`[SetQualityPreference] saved graphics quality preference: ${value}`);
};

export const UpdateUrlParams = (key, value) => {
    const result = {};
    let cachedJson = localStorage.getItem(cachedParamsTag);
    if (cachedJson !== null && cachedJson !== '') {
        let cachedParams = JSON.parse(cachedJson);

        // Update cachedParams with key/values
        cachedParams[key] = value;

        const json = JSON.stringify(cachedParams);
        localStorage.setItem(cachedParamsTag, json);
    } else {
        result[key] = value;
        const json = JSON.stringify(result);
        localStorage.setItem(cachedParamsTag, json);
    }
    console.log(`[UpdateUrlParams] updated cached params with: ${localStorage.getItem(cachedParamsTag)}`);
};